"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICustomerSettings = exports.ISettings = void 0;
const openapi_1 = require("../../../openapi");
const ICustomerAssignmentDetail_1 = require("../customerAssignments/ICustomerAssignmentDetail");
const IInvoice_1 = require("../invoice/IInvoice");
const IInvoiceNumberSettings_1 = require("../invoice/IInvoiceNumberSettings");
const INotificationConfiguration_1 = require("../notifications/INotificationConfiguration");
const ICustomerBase_1 = require("./ICustomerBase");
class ICustomerAddress {
    addr1;
    addr2;
    city;
    state;
    zip;
    country;
    contactName;
    contactPhone;
    contactEmail;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "addr1", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "addr2", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "city", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "state", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "zip", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "country", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "contactName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerAddress.prototype, "contactPhone", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'email' })
], ICustomerAddress.prototype, "contactEmail", void 0);
class IGlAccountCategoryOverrides {
    category;
    glAccount;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IGlAccountCategoryOverrides.prototype, "category", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IGlAccountCategoryOverrides.prototype, "glAccount", void 0);
class IGlAccountTransactionOverrides {
    transactionType;
    glAccount;
    categoryOverrides;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IGlAccountTransactionOverrides.prototype, "transactionType", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IGlAccountTransactionOverrides.prototype, "glAccount", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IGlAccountCategoryOverrides) })
], IGlAccountTransactionOverrides.prototype, "categoryOverrides", void 0);
class ICustomerGlAccountSettings {
    defaultGlAccount;
    transactionOverrides;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ICustomerGlAccountSettings.prototype, "defaultGlAccount", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IGlAccountTransactionOverrides) })
], ICustomerGlAccountSettings.prototype, "transactionOverrides", void 0);
class IAutoInvoiceSettings {
    frequency;
    lastInvoice;
    nextInvoice;
    startsOn;
    invoiceBy;
    autoPublish;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(IInvoice_1.InvoiceFrequency) })
], IAutoInvoiceSettings.prototype, "frequency", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IAutoInvoiceSettings.prototype, "lastInvoice", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IAutoInvoiceSettings.prototype, "nextInvoice", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IAutoInvoiceSettings.prototype, "startsOn", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(IInvoice_1.IInvoicedBy) })
], IAutoInvoiceSettings.prototype, "invoiceBy", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], IAutoInvoiceSettings.prototype, "autoPublish", void 0);
class ICustomerConvenienceFeesSettings {
    CCFeeEnabled;
    ACHFeeEnabled;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], ICustomerConvenienceFeesSettings.prototype, "CCFeeEnabled", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], ICustomerConvenienceFeesSettings.prototype, "ACHFeeEnabled", void 0);
class ISettings {
    glAccountSettings;
    primaryAddress;
    secondaryAddress;
    payrixCustomerId;
    invoiceNumberSettings;
    allowCCPayment;
    allowACHPayment;
    paymentTerm;
    autoInvoice;
    autoInvoiceSettings;
    convenienceFeesSettings;
    notificationSettings;
}
__decorate([
    (0, openapi_1.Schema)(() => ICustomerGlAccountSettings)
], ISettings.prototype, "glAccountSettings", void 0);
__decorate([
    (0, openapi_1.Schema)(() => ICustomerAddress)
], ISettings.prototype, "primaryAddress", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => ICustomerAddress)
], ISettings.prototype, "secondaryAddress", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ISettings.prototype, "payrixCustomerId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IInvoiceNumberSettings_1.IInvoiceNumberSettings)
], ISettings.prototype, "invoiceNumberSettings", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], ISettings.prototype, "allowCCPayment", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], ISettings.prototype, "allowACHPayment", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], ISettings.prototype, "paymentTerm", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], ISettings.prototype, "autoInvoice", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IInvoiceNumberSettings_1.IInvoiceNumberSettings)
], ISettings.prototype, "autoInvoiceSettings", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => ICustomerConvenienceFeesSettings)
], ISettings.prototype, "convenienceFeesSettings", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => INotificationConfiguration_1.INotificationConfiguration)
], ISettings.prototype, "notificationSettings", void 0);
exports.ISettings = ISettings;
class ICustomerSettings extends ICustomerBase_1.ICustomerBase {
    settings;
    warehouses;
}
__decorate([
    (0, openapi_1.Schema)(() => ISettings)
], ICustomerSettings.prototype, "settings", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => ICustomerAssignmentDetail_1.ICustomerWarehouse) })
], ICustomerSettings.prototype, "warehouses", void 0);
exports.ICustomerSettings = ICustomerSettings;
